import React from "react";
import { useSelector } from "types/store";
import Lineage from "components/Lineage/Lineage";
import * as chatAppReducer from "containers/ChatApp/reducer";
const UseCaseLineage = ({ id, workflowOrigin }) => {
    const lineage = useSelector((state) => chatAppReducer.getLineage(state, id));
    return React.createElement(Lineage, { lineage: lineage, workflowOrigin: workflowOrigin });
};
export default UseCaseLineage;
